import React, { useEffect, useState } from "react"
import { injectIntl } from "react-intl"
import Select from "react-select"
import {

    ECOMMERCE_RULE_KEY,
    ECOMMERCE_RULE_TYPE,
    ECOMMERCE_RULE_VALUE_TYPE,
    ECOMMERCE_RULE_TYPES_STRING,
    ECOMMERCE_RULE_TYPES_BOOLEAN,
    getEcommerceRuleValueType,
} from "../../../state/ecommerce-configuration/EcommerceRule"
import { Intl } from "../../../state/helpers/IntlProps"
import {
    RULE_TYPE_SELECT_MESSAGES,
} from "../../../state/ecommerce-configuration/messages/EcommerceRuleMessages"

type Props = {
    intl: Intl,
    onUpdate: (ruleType: string) => void,
    disabled: boolean,
    ruleKey: ECOMMERCE_RULE_KEY,
    selectedRuleType?: ECOMMERCE_RULE_TYPE,
}

const EcommerceRuleTypeSelect = (props: Props) => {
    const [ruleKey, setRuleKey] = useState<string>(props.ruleKey)

    const getRuleOptions = (ruleKey: string) => {
        let RULE_TYPES: string[]

        switch (getEcommerceRuleValueType(ruleKey)) {
        case ECOMMERCE_RULE_VALUE_TYPE.VALUE_TYPE_BOOLEAN:
            RULE_TYPES = ECOMMERCE_RULE_TYPES_BOOLEAN
            break
        case ECOMMERCE_RULE_VALUE_TYPE.VALUE_TYPE_STRING:
        default:
            RULE_TYPES = ECOMMERCE_RULE_TYPES_STRING
        }

        return RULE_TYPES.map(ruleType => {
            return {
                label: props.intl.formatMessage(RULE_TYPE_SELECT_MESSAGES[ruleType]),
                value: ruleType,
            }
        })
    }

    const RULE_TYPE_OPTIONS = getRuleOptions(props.ruleKey)

    const [selectedRuleTypeOption, setSelectedRuleTypeOption] = useState(props.selectedRuleType ? {
        label: props.intl.formatMessage(RULE_TYPE_SELECT_MESSAGES[props.selectedRuleType]),
        value: props.selectedRuleType,
    } : RULE_TYPE_OPTIONS[0])

    useEffect(() => {
        const newRuleKeyValueType = getEcommerceRuleValueType(props.ruleKey)
        if (newRuleKeyValueType !== getEcommerceRuleValueType(ruleKey)) {
            const UPDATED_RULE_TYPE_OPTIONS = getRuleOptions(props.ruleKey)
            setSelectedRuleTypeOption(UPDATED_RULE_TYPE_OPTIONS[0])
            props.onUpdate(UPDATED_RULE_TYPE_OPTIONS[0].value)
        }

        setRuleKey(props.ruleKey)
    }, [props.ruleKey])

    return (
        <Select
            className="rule-type"
            placeholder={props.intl.formatMessage(RULE_TYPE_SELECT_MESSAGES.select)}
            value={selectedRuleTypeOption}
            onChange={(selectedOption) => {
                setSelectedRuleTypeOption(selectedOption)
                props.onUpdate(selectedOption.value)
            }}
            options={RULE_TYPE_OPTIONS}
            clearable={false}
            searchable={false}
            disabled={props.disabled}
            multi={false}
        />
    )
}

export default injectIntl(EcommerceRuleTypeSelect)



// WEBPACK FOOTER //
// ./src/settings/ecommerce/components/EcommerceRuleTypeSelect.tsx